import React, { createElement, useEffect, useState } from 'react';
import './index.scss';
import { AreaChart, LineChart } from 'bizcharts';
import { Message } from '@alifd/next';
import { previewDataByField } from '../../../api/common/index';
import { dealArray, dealOrderByBoList, dealFieldByList } from '../../../utils';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const ALineChart = (props, ref) => {
    const { dataSource, fill, data, showLine, showDot, dotShape, dotSize, lineSize, color, xAxis, yAxis, plugins, hasTitle, titleText, ...other } = props;
    const [idata, setIdata] = useState([]);
    const [xProps, setXprops] = useState('month');
    const [yProps, setYprops] = useState('temperature');
    const [series, setSeries] = useState('city');
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    useEffect(() => {
        setError(false);
        try {
            if (dataSource?.xaxis.length && dataSource?.yaxis.length) {
                const limit = dataSource?.limit || [100];
                if (limit[0] > 1000) {
                    Message.error('最多显示前1000条!');
                    return;
                }
                const fl = dataSource?.filter || [];
                const params = {
                    groupId: dataSource.dataset.id,
                    type: 'LineChart',
                    fieldList: dealFieldByList([
                        ...dataSource.xaxis,
                        ...dataSource.yaxis,
                        ...dataSource.group,
                    ]),
                    horizontalAxis: dealArray(dataSource.xaxis),
                    longitudinalAxis: dealArray(dataSource.yaxis).map((e) => ({
                        ...e,
                        aggregateType: e?.aggregateType || 'COUNT',
                    })),
                    groupAxis: dealArray(dataSource.group),
                    orderByBoList: dealOrderByBoList([...dataSource.xaxis, ...dataSource.group]),
                    resultCount: limit[0] === undefined ? 100 : limit[0],
                    customFilterVo: fl[0] === undefined
                        ? null
                        : {
                            logic: 'and',
                            filterVos: [dataSource?.filter[0] || null].filter((e) => e),
                        },
                };
                previewDataByField(params).then((res) => {
                    const fields = res?.data?.fields;
                    if (!fields) {
                        Message.error(res?.msg);
                        return;
                    }
                    const xp = fields.find((e) => e.id === dataSource.xaxis[0].id)?.fieldShortName || 'defalut';
                    const yp = fields.find((e) => e.id === dataSource.yaxis[0].id)?.fieldShortName || 'defalut';
                    const se = fields.find((e) => e.id === dataSource.group[0]?.id)?.fieldShortName || 'defalut';
                    setXprops(xp);
                    setYprops(yp);
                    setSeries(se);
                    let tempData = res.data.data.map((e) => {
                        for (let item of dataSource.yaxis) {
                            e[item.fieldShortName] = Number(e[item.fieldShortName]);
                        }
                        if (!dataSource.group.length) {
                            e.defalut = '默认';
                        }
                        return e;
                    });
                    if (dataSource?.xaxis[0]?.additional?.sort) {
                        const sortArr = dataSource?.xaxis[0]?.additional?.sort.filter((e) => e.checked);
                        const sortList = [];
                        sortArr.forEach((item) => {
                            tempData.forEach((itm) => {
                                if (itm[dataSource?.xaxis[0]?.fieldShortName] === item.name) {
                                    sortList.push(itm);
                                }
                            });
                        });
                        tempData = sortList;
                    }
                    setIdata(tempData);
                });
            }
            else {
                setXprops('month');
                setYprops('temperature');
                setSeries('city');
                setIdata(data);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('初始化数据出错,请在数据源面板重新配置字段或更新组件');
        }
    }, [dataSource]);
    const getColor = (list) => {
        return list || 'blue';
    };
    const [interactions, setInteractions] = useState([]);
    useEffect(() => {
        try {
            const arr = plugins?.visible
                ? [
                    {
                        type: 'slider',
                        cfg: {
                            start: plugins.start,
                            end: plugins.end,
                        },
                    },
                ]
                : [];
            setInteractions(arr);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('缩略轴渲染异常,请更新组件');
        }
    }, [props.plugins?.visible]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, className: "base_bg" },
        hasTitle ? (createElement("div", { className: "datasettitle" }, titleText || dataSource?.dataset?.name)) : null,
        fill ? (createElement(AreaChart, Object.assign({ height: 400, forceUpdate: true, areaStyle: {
                fill: fill ? '' : 'transparent',
            } }, other, { line: {
                visible: showLine,
                size: lineSize,
            }, data: idata, color: getColor(color ? color.split(',') : []), point: {
                visible: showDot,
                shape: dotShape,
                size: dotSize,
                style: {},
            }, label: props?.labeldata, xAxis: {
                visible: xAxis?.visible,
                title: {
                    visible: xAxis?.showTitle,
                    text: xAxis?.title,
                },
                line: {
                    visible: xAxis?.line,
                },
                tickLine: {
                    visible: xAxis?.tickLine,
                },
                line: {
                    visible: xAxis?.line,
                },
                tickLine: {
                    visible: xAxis?.tickLine,
                },
                grid: {
                    visible: xAxis?.grid,
                },
                label: {
                    visible: xAxis?.label,
                    style: {
                        fill: xAxis?.labelColor,
                        fontSize: xAxis?.labelSize,
                        width: xAxis?.labelLength === 'percent'
                            ? xAxis?.labelPercentWidth
                            : xAxis?.labelFixedWidth,
                    },
                    autoHide: xAxis?.autoHide,
                    autoRotate: xAxis?.autoRotate,
                    ...(xAxis?.autoRotate
                        ? {}
                        : { rotate: (xAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                },
            }, yAxis: {
                visible: yAxis?.visible,
                title: {
                    visible: yAxis?.showTitle,
                    text: yAxis?.title,
                },
                line: {
                    visible: yAxis?.line,
                },
                tickLine: {
                    visible: yAxis?.tickLine,
                },
                line: {
                    visible: yAxis?.line,
                },
                tickLine: {
                    visible: yAxis?.tickLine,
                },
                grid: {
                    visible: yAxis?.grid,
                },
                label: {
                    visible: yAxis?.label,
                    style: {
                        fill: yAxis?.labelColor,
                        fontSize: yAxis?.labelSize,
                        width: yAxis?.labelLength === 'percent'
                            ? yAxis?.labelPercentWidth
                            : yAxis?.labelFixedWidth,
                    },
                    autoHide: yAxis?.autoHide,
                    autoRotate: yAxis?.autoRotate,
                    ...(yAxis?.autoRotate
                        ? {}
                        : { rotate: (yAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                },
            }, interactions: interactions, seriesField: series, xField: xProps, yField: yProps }))) : (createElement(LineChart, Object.assign({ height: 400, forceUpdate: true, areaStyle: {
                fill: fill ? '' : 'transparent',
            } }, other, { line: {
                visible: showLine,
                size: lineSize,
            }, data: idata, color: getColor(color ? color.split(',') : []), point: {
                visible: showDot,
                shape: dotShape,
                size: dotSize,
                style: {},
            }, label: props?.labeldata, xAxis: {
                visible: xAxis?.visible,
                title: {
                    visible: xAxis?.showTitle,
                    text: xAxis?.title,
                },
                line: {
                    visible: xAxis?.line,
                },
                tickLine: {
                    visible: xAxis?.tickLine,
                },
                line: {
                    visible: xAxis?.line,
                },
                tickLine: {
                    visible: xAxis?.tickLine,
                },
                grid: {
                    visible: xAxis?.grid,
                },
                label: {
                    visible: xAxis?.label,
                    style: {
                        fill: xAxis?.labelColor,
                        fontSize: xAxis?.labelSize,
                        width: xAxis?.labelLength === 'percent'
                            ? xAxis?.labelPercentWidth
                            : xAxis?.labelFixedWidth,
                    },
                    autoHide: xAxis?.autoHide,
                    autoRotate: xAxis?.autoRotate,
                    ...(xAxis?.autoRotate
                        ? {}
                        : { rotate: (xAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                },
            }, yAxis: {
                visible: yAxis?.visible,
                title: {
                    visible: yAxis?.showTitle,
                    text: yAxis?.title,
                },
                line: {
                    visible: yAxis?.line,
                },
                tickLine: {
                    visible: yAxis?.tickLine,
                },
                line: {
                    visible: yAxis?.line,
                },
                tickLine: {
                    visible: yAxis?.tickLine,
                },
                grid: {
                    visible: yAxis?.grid,
                },
                label: {
                    visible: yAxis?.label,
                    style: {
                        fill: yAxis?.labelColor,
                        fontSize: yAxis?.labelSize,
                        width: yAxis?.labelLength === 'percent'
                            ? yAxis?.labelPercentWidth
                            : yAxis?.labelFixedWidth,
                    },
                    autoHide: yAxis?.autoHide,
                    autoRotate: yAxis?.autoRotate,
                    ...(yAxis?.autoRotate
                        ? {}
                        : { rotate: (yAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                },
            }, interactions: interactions, seriesField: series, xField: xProps, yField: yProps })))))));
};
export default React.forwardRef(ALineChart);
